import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSiteContent } from '../context/SiteContent';
import { availableRoomNumbers } from '../services/schedule';
import SiteImage from './SiteImage';
import './available-rooms.css';

export default function AvailableRooms({ checkIn, checkOut, guests }) {
  const { site } = useSiteContent();
  const [numbers, setNumbers] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!checkIn || !checkOut || checkOut <= checkIn) return;
    let active = true;
    availableRoomNumbers(checkIn, checkOut).then((result) => {
      if (active) { setNumbers(result); setLoading(false); }
    }).catch((reason) => {
      if (active) { setError(reason.message); setLoading(false); }
    });
    return () => { active = false; };
  }, [checkIn, checkOut]);

  if (!checkIn || !checkOut || checkOut <= checkIn) return null;

  return (
    <div className="available-rooms" aria-live="polite">
      <span className="eyebrow">Availability for your dates</span>
      <h3>Rooms open for your stay</h3>
      {loading && <p>Checking room schedule…</p>}
      {error && <p role="alert">Availability could not be checked: {error}. Please contact us before planning around these dates.</p>}
      {!loading && !error && numbers.length === 0 && <p>No rooms are available for all of the selected nights.</p>}
      {!loading && !error && numbers.length > 0 && (
        <div className="available-rooms-list">
          {site.rooms.filter((room) => numbers.includes(room.number)).map((room) => (
            <Link key={room.number} to={`/rooms/${room.number}?${new URLSearchParams({ checkIn, checkOut, guests })}`}>
              <div className="available-room-media">
                <SiteImage src={room.image} alt={room.alt || `${room.title} room interior`} className="available-room-photo" />
                <span className="available-room-ribbon">Available</span>
              </div>
              <strong>{room.title}</strong><span>View room →</span>
            </Link>
          ))}
        </div>
      )}
      <p>Availability can change before your request is confirmed.</p>
    </div>
  );
}